import api from './api';
import { getItem } from './localSorage';

import HistoryInterface from '../interfaces/history';

interface HistoryResponse {
  data: any;
}

export const fetch = (prescriptionToken: string): Promise<HistoryInterface[]> => {
  const params = [`token=${getItem('token')}`, `prescription_token=${prescriptionToken}`].join('&');
  const uri = `dispenser/history?${params}`;

  return api.get(uri).then((response: HistoryResponse) => {
    return normalize(response.data);
  });
};

const normalize = (response: any): HistoryInterface[] => {
  return response.data.map((item: any) => {
    return {
      id: item.history.id,
      // foi necessario realizar esse replace para compatibilidade com o ie10
      date: new Date(item.history.created_at.replace(' ', 'T')),
      itemId: item.history.prescription_item_id,
      user: {
        name: item.user.name,
      },
      drugstore: {
        name: item.drugstore.chain.name,
      },
      action: item.history.action,
    };
  });
};
